import type { FormControlLabelProps } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { forwardRef } from 'react';
import type { CheckboxProps } from './Checkbox';
import { Checkbox } from './Checkbox';

export interface CheckboxWithLabelProps extends Omit<FormControlLabelProps, 'control'> {
  /** Props passed down to Checkbox component */
  checkboxProps?: CheckboxProps;
}

/** Basic checkbox component with label */
export const CheckboxWithLabel = forwardRef<HTMLInputElement, CheckboxWithLabelProps>(
  ({ checkboxProps, ...props }, ref) => {
    const { sx: checkboxSx, ...otherCheckboxProps } = { ...checkboxProps };

    return (
      <FormControlLabel
        {...props}
        inputRef={ref}
        control={
          <Checkbox
            {...otherCheckboxProps}
            sx={{ ...checkboxSx, marginTop: '-0.25em' }}
            data-testid="checkbox"
          />
        }
        sx={{ alignItems: 'flex-start', paddingTop: '0.25rem' }}
      />
    );
  },
);
